<template>
  <div v-show="isdisplay" onselectstart="return false;" style="user-select:none" class="dragResize">
    <div :style="dragStyle">
      <VueDragResize :isActive="true" :w="width" :h="height" :isResizable="false" :z="6670">
        <div style="text-align:center; border:1px solid #eee;border-radius:5px;" ref="drag1">
          <img
            class="img"
            ref="drag2"
            v-for="(item,index) in imgList"
            v-if="index ==0"
            :key="index"
            :src="item.url"
            title="点我伸缩哦~"
            @click="click(item.vname,index)"
          />

          <img
            class="img"
            v-for="(item,index) in imgList"
            v-if="index >=1"
            v-show="isShow"
            :key="index"
            :src="item.url"
            :title="item.title"
            @click="click(item.vname,index)"
          />
          <!-- @mouseover="changeIndex(index)"
          @mouseout="changeIndexBack(index)"-->
        </div>
      </VueDragResize>
    </div>
    <div
      class="popContainer"
      v-show="show"
      @mousedown="pressEnlarge"
      @mouseup="stop"
      @mousemove="move"
      ref="dragHover"
    ></div>
    <div
      class="popContainer"
      v-show="showNo"
      @mousedown="pressNarrow"
      @mouseup="stop"
      @mousemove="move"
      ref="dragHover1"
    ></div>
  </div>
</template>
<script>
import VueDragResize from "vue-drag-resize";
import { fabric } from "fabric";
export default {
  name: "dragResize",

  components: {
    VueDragResize,
  },
  beforeMount: function () {},
  mounted: function () {
    this.$store.registerModule(["system", "dragResize"], {
      state: {
        $: this,
      },
    });
  },
  data() {
    return {
      //存储原始数据
      rawData:{},
      isdisplay: 0,
      zoomList: { x: 0, y: 0 },
      isZoom: false, //是否拖动对象
      show: false, //放大显隐
      showNo: false, //缩小显隐
      scale: 0.5,
      zoomNum: 1, //缩放比例
      isShow: true, //拖动图标组件的展开是否
      animationType: true,
      width: 40,
      height: 5,
      timer: "",
      dragStyle: {
        position: "absolute",
        left: "0%", //1300
        top: "0%", //40
      },

      dragImg: {
        canDrag: false,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      displayList: [],
      imgList: [
        {
          vname: "drag",
          url: "../../../static/drag.png",
          src: "../../../static/drag.png",
          uri: "../../../static/drag_active.png",
        },
      ],
      imgList1: [
        {
          vname: "drag",
          url: "../../../static/drag.png",
          src: "../../../static/drag.png",
          uri: "../../../static/drag_active.png",
        },
        {
          vname: "enlarge",
          title: "放大",
          url: "../../../static/enlarge.png",
          src: "../../../static/enlarge.png",
          uri: "../../../static/enlarge_active.png",
        },
        {
          vname: "narrow",
          title: "缩小",
          url: "../../../static/narrow.png",
          src: "../../../static/narrow.png",
          uri: "../../../static/narrow_active.png",
        },
        {
          vname: "kefu",
          title: "复原",
          url: "../../../static/fuyuan.png",
          src: "../../../static/fuyuan.png",
          uri: "../../../static/fuyuan_active.png",
        },
        {
          vname: "home",
          title: "主页",
          url: "../../../static/home.png",
          src: "../../../static/home.png",
          uri: "../../../static/home_active.png",
        },
        {
          vname: "quit",
          title: "退出",
          url: "../../../static/quite.png",
          src: "../../../static/quite.png",
          uri: "../../../static/quite_active.png",
        },
      ],
    };
  },

  computed: {
    scaleFun: function () {
      var zoomNum = this.zoomNum;
      return `transform:scale(${zoomNum})`;
    },
  },

  methods: {
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    //组件显隐
    openShow(value) {
      if(value == undefined) return;
      if (value.length !== 0) {
        //存储原始值，再其他组件进行控制
        this.rawData = value;
        this.isdisplay = value.isdisplay;
        this.isShow = value.isExpand;
        this.dragStyle.left = value.left;
        this.dragStyle.top = value.top;
        this.displayList = value.displayList;
        for (var item in this.imgList1) {
          for (var j in this.displayList) {
            if (this.imgList1[item].vname == this.displayList[j]) {
              this.imgList.push(this.imgList1[item]);
              this.imgList = Array.from(new Set(this.imgList));
            }
          }
        }
      } else {
        this.imgList = [];
      }
    },
    
    //图标点击方法
    click(name, index) {
      this[name]();
      for (var i in this.imgList) {
        if (i == index) {
          this.imgList[i].url = this.imgList[i].uri;
        } else {
          this.imgList[i].url = this.imgList[i].src;
        }
      }
    },
    onmouseup: (e) => {
      this.mouseDown = false;
      this.animationType = true;
    },
    //缩放后拖动
    onmousedown: (e) => {
      this.mouseDown = true;
      this.mouseDownPos = {
        x: e.clientX,
        y: e.clientY,
      };
    },
    //拖动
    drag() {
      this.isShow = !this.isShow;
      if (this.isShow !== false) {
        this.$refs.drag2[0].style.borderWidth = "0px";
        this.$refs.drag1.style.borderWidth = "1px";
        this.$refs.drag1.style.borderStyle = "solid";
        this.$refs.drag1.style.borderColor = "#eee";
        this.$refs.drag1.style.borderRadius = "5px";
      }
      this.showNo = false;
      this.show = false;
      //this.$store.state.system.$.isZoom = true;
    },
    //放大
    pressEnlarge(e) {
      //鼠标左键点击
      if (e.button == 0) {
        this.$refs.dragHover.classList.remove("supportStyle");
        this.timer = setInterval(() => {
          this.mouseZoom(e,"enlarge");
        }, 100);
      }
    },
    //缩小
    pressNarrow(e) {
      //鼠标左键点击
      if (e.button == 0) {
        this.$refs.dragHover1.classList.remove("supportStyle");
        this.timer = setInterval(() => {
          this.mouseZoom(e,"narrow");
        }, 100);
      }
    },
    stop(e) {
      clearInterval(this.timer);
    },
    move(e) {
      clearInterval(this.timer);
      if (this.show == true) { 
        this.$refs.dragHover.classList.add("supportStyle");
         this.$store.state.system.$.isZoom = true;
      }
      if (this.showNo == true) {
          this.$refs.dragHover1.classList.add("supportStyle"); 
           this.$store.state.system.$.isZoom = true;
      }
    },
    //在打开窗口获取鼠标位置 用于中心与鼠标位置对其
    onmousemoves: (e) => {
      window.onmousemoveX = e.pageX;
      window.onmousemoveY = e.pageY;
      if (this.$store.state.system.$.isZoom == true && this.mouseDown) {
        const ls = e.clientX - this.mouseDownPos.x;
        const lt = e.clientY - this.mouseDownPos.y;
        //用于缩放后拖拽  后在次打开新窗口
        this.zoomList.x += ls;
        this.zoomList.y += lt;

        this.$store.state.system.$.zoomList.x += x/2;
        this.$store.state.system.$.zoomList.y += y/2;

        this.mouseDownPos = {
          x: e.clientX,
          y: e.clientY,
        };
        if (this.animationType) {
          this.animationType = false;
        }
        for (let p in this.$store.state.system.manager) {
          if (p != "$") {
            this.$store.state.system.manager[p].$.setPosition(ls, lt);
            this.$store.state.system.manager[p].$.onDraw();
          }
        }
      }
    },
    //放大
    enlarge() {
      this.show = !this.show;
      this.showNo = false;
      if (this.show == false) {
        for (var i in this.imgList) {
          if (this.imgList[i].vname == "enlarge") {
            this.imgList[i].uri = "../../../static/enlarge.png";
          }
        }
      } else {
        for (var i in this.imgList) {
          if (this.imgList[i].vname == "enlarge") {
            this.imgList[i].uri = "../../../static/enlarge_active.png";
          }
        }
      }
    },
    //缩小
    narrow() {
      this.showNo = !this.showNo;
      this.show = false;
      if (this.showNo == false) {
        for (var is in this.imgList) {
          if (this.imgList[is].vname == "narrow") {
            this.imgList[is].uri = "../../../static/narrow.png";
          }
        }
      } else {
        for (var is in this.imgList) {
          if (this.imgList[is].vname == "narrow") {
            this.imgList[is].uri = "../../../static/narrow_active.png";
          }
        }
      }
    },
    //鼠标按下缩放
    mouseZoom(e,value) {
      if(value == "enlarge"){
        var step = -10;
      }else{
        var step = 10;
      }
      var sy = innerWidth / innerHeight;
      this.$store.state.system.$.screenWidth += step * sy;
      this.$store.state.system.$.screenHeight += step ;
      var x = step * (e.pageX / innerWidth) * sy;
      var y = step * (e.pageY / innerHeight);
      //用于缩放后拖拽  后在次打开新窗口
      this.$store.state.system.$.zoomList.x +=x ;
      this.$store.state.system.$.zoomList.y +=y ;
      for(let p in this.$store.state.system.manager){
        if(p != "$"){
            if(!this.$store.state.system.$.indexDB[0].isSvg){
                this.$store.state.system.manager[p].$.$refs.canvasNode.classList.add("my_close");
            }else{
                this.$store.state.system.manager[p].$.$refs.svgNode.classList.add("my_close");
            }
            // this.$store.state.system.manager[p].$.zoomMagnification();
            this.$store.state.system.manager[p].$.repaint({
                x : x,
                y : y
            });
            this.$store.state.system.manager[p].$.onDraw();
        }
      }
    },
    //跳转到主页
    home() {
      this.kefu();
      this.$store.state.system.$.Homepage();
      this.$store.state.system.$.isZoom = false;
    },
    setting() {},
    //退出
    quit() {
      this.kefu();
      this.$store.state.system.$.LogOut();
      this.$store.state.system.$.zoomList.x = 0 ;
      this.$store.state.system.$.zoomList.y = 0;
    },
    //复原
    kefu() {
      for (let temp in this.$store.state.system.manager) {
        if (temp != "$") {
          this.$store.state.system.manager[temp].$.repaint("reduction");
          this.$store.state.system.manager[temp].$.onDraw();
        }
      }
      this.$store.state.system.$.zoomList.x = 0 ;
      this.$store.state.system.$.zoomList.y = 0;
      this.$store.state.system.$.isZoom = false;
      this.show = false;
      this.showNo = false;
    },
  },
};
</script>
<style>
html {
  overflow-x: hidden;
  overflow-y: hidden;
}
.vdr.active:before {
  outline: none;
}
.vdr.active {
  top: 50%;
  left: 50%;
}
.img {
  width: 70%;
  margin-top: 10px;
  cursor: pointer;
}
.img1 {
  width: 8%;
  cursor: pointer;
}
div.pContainer {
  position: fixed;
  top: 0;
  left: 40%;
}
div.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 5555;
}
.drag2 {
  border: 1px solid #eee;
  border-radius: 50%;
}
.drag1 {
  border: 1px solid #eee;
  border-radius: 5px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.supportStyle:hover {
  cursor: -webkit-grabbing !important;
}
.dragResize .vdr.active:before{
  outline:0px dashed #d6d6d6 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/system/dragResize.vue